import { Component, type ReactNode } from 'react';
import { refreshAll } from '../lib/query.ts';
import { stored } from '../lib/storage.ts';

/**
 * A section that fails to render shows what happened and a way back, instead of leaving the whole
 * app black. The usual cause is a copy of data saved by an older version: «Обновить» drops the
 * saved copies and loads everything again.
 */
export class PageGuard extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error('[page]', error);
  }

  retry = async () => {
    // saved copies go; queries of the failed section were dropped with it and load afresh on retry
    stored.clear();
    try { await refreshAll(); } catch { /* offline: the section retries with what it gets */ }
    this.setState({ error: null });
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="error-box page-error" role="alert">
        <span>Раздел не открылся: {this.state.error.message}</span>
        <button type="button" className="btn btn-sm" onClick={() => void this.retry()}>Обновить</button>
      </div>
    );
  }
}
